import { Injectable } from '@zhfe/vue2-di-plugin'

export interface ToastConfig {
  duration?: number
  callback?(): void
}

@Injectable()
export class ToastService {
  constructor (private toast: Function) {
  }

  show (content: string, config?: ToastConfig) {
    this.toast(content, config)
  }
}
